import ErrorBoundary, { type ErrorBoundaryProps } from "@common/controls/ErrorBoundary/component";

export { type ErrorBoundaryProps };
export default ErrorBoundary;
